<template>
  <div></div>
</template>

<script>
import NtrPaslaugosMap from '../components/ntrpaslaugos/NtrPaslaugosMap'
import math from '../mixins/math'

export default {
  name: 'Krepselis',
  mixins: [math],
  props: {
    ntrpaslaugos: { type: Boolean, default: false },
  },
  created() {
    this.checkNtrpaslaugos()
  },
  methods: {
    checkNtrpaslaugos() {
      const paslaugaID = this.$route.params.paslaugaID

      const nepPaslaugos = [
        '400',
        '401',
        '402',
        '404',
        '407',
        '1017',
        '1018',
        '1042',
        '1711',
        '1712',

        // pazyma ir sklypas
        '1037',
        '1097',
      ]
      if (!this.ntrpaslaugos && nepPaslaugos.includes(paslaugaID)) {
        const fullPath = this.$route.fullPath
        const newPath = fullPath.replace(
          '/krepselis',
          'ntr-paslaugos/ntr-krepselis'
        )
        window.location.href = `${process.env.VUE_APP_SAVITARNA_URL}${newPath}`
        return
      }

      if (process.env.VUE_APP_LOCAL === 'local') {
        this.krepselisRedirect()
        return
      }

      this.checkIpasas()
    },
    checkIpasas() {
      this.userAuth = false

      this.$axios
        .post(`ipasas`, { enc: this.$route.query.enc })
        .then(res => {
          if (res && res.status === 200) {
            const dispatchData = {
              naudotojas: res.data.naudotojas,
              roles: res.data.roles,
              xid: this.$route.query.xid,
            }
            this.$store.dispatch('savitarnaLogin', dispatchData).then(() => {
              this.$store.dispatch('loadTooltips')
              this.userAuth = true
              if (res.data.pirmas_prisijungimas) {
                this.$store.dispatch('savitarnaSutartis', false)
              }
              this.krepselisRedirect()
            })
          }
        })
        .catch(err => {
          window._VMA.$emit('SAV_LOGIN_ERROR')
        })
    },
    krepselisRedirect() {
      const paslaugaID = this.$route.params.paslaugaID
      const uzsakymasID = this.$route.params.uzsakymasID

      const data = { paslauga_id: paslaugaID, uzs_id: uzsakymasID }
      this.$axios
        .post(`krepselis`, data)
        .then(res => {
          const objektasID = res.data.data.obj_id
          const paieskaID = res.data.data.pai_id
          const prasymasID = res.data.data.pra_id
          const pazymaID = res.data.data.paz_id
          const bylaID = res.data.data.byl_id

          if (objektasID) {
            this.$router.push({
              name: 'hipotekaRegistravimas',
              params: {
                objektasID: objektasID,
              },
            })
            return
          }
          if (paieskaID) {
            this.$store
              .dispatch('searchParams', {
                route: 'savPaieskaMano',
                mainData: {},
                extraData: {
                  pai_numeris: `${paieskaID}`,
                },
                isExpanded: 1,
              })
              .then(
                this.$router.push({
                  name: 'savPaieskaMano',
                })
              )
            return
          }
          if (bylaID) {
            this.showByla(res.data.data)
            // return
          }
          if (prasymasID) {
            const prasymasTipas = res.data.data.pra_tipas
            const prasymasMap = NtrPaslaugosMap.getPrasymasTipas(prasymasTipas)
            this.$router.push({
              name: prasymasMap.routeSign,
              params: {
                prasymasID: prasymasID,
                step: 'registravimas',
              },
            })
            return
          }
          if (pazymaID) {
            this.$store
              .dispatch('searchParams', {
                route: 'ntrDokumentai',
                mainData: {},
                extraData: {
                  pra_id: `${pazymaID}`,
                },
                isExpanded: 1,
              })
              .then(
                this.$router.push({
                  name: 'ntrDokumentai',
                })
              )
            return
          }
          this.$router.push({ name: 'home' })
        })
        .catch(err => {
          this.$router.push({ name: 'home' })
        })
    },
    showByla(byla) {
      const bylaUrl = `${this.ntrpaslaugos ? 'ntrpaslaugos/' : ''}byla/${
        byla.byl_id
      }/${byla.byl_hash}/content`

      this.$axios
        .get(bylaUrl, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          this.openFile(res.data, byla.byl_pavadinimas)
        })
        .catch(err => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          window._VMA.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {})
    },
    openFile(fileData, fileName) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', this.safeFileName(fileName))
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>
